import { Pipe, PipeTransform } from "@angular/core";
import type { ITypeBase } from "../../interfaces/BaseEntity";

@Pipe({ name: "typeDescription" })
export class TypeDescriptionPipe implements PipeTransform {
    transform(value: string | number, array: ITypeBase[] = []): string {
        const type = array.find((x) => x.ID === value);

        return type ? type.Description : "";
    }
}
